import { FC, useEffect } from "react";
import Slider, { Settings } from "react-slick";
import { SliderArrowProps, TestimonialsProps } from "../../testimonials.types";
import TestimonialsCard from "../../components/testimonials-card/testimonials-card";
import styles from "./testimonials-1.module.css";
import { UiButton } from "@ui-monorepo/index";
import useTestimonials from "../../testimonials.hook";
import WidgetContainer from "../../../widget-container";

const Testimonials1: FC<TestimonialsProps> = (props) => {
  const {
    t,
    sliderRef,
    testimonials,
    highLight,
    testimonialType,
    sliderLoad,
    setSliderLoad,
    handleChange
  } = useTestimonials(props);

  const SliderArrow = ({ className, onClick }: SliderArrowProps) => {
    return (
      <UiButton
        isBlack
        appearance='icon'
        className={className || ""}
        leftIcon={<span className='icon-arrow-right' />}
        onClick={onClick}
        theme={props.theme} />);


  };

  const settings = (): Settings => {
    return {
      className: `${styles.testimmonial1Slider} ${
      testimonials?.length === 1 ? "slider-simple-center" : ""
      } ${sliderLoad ? styles.sliderLoaded : ""}`,
      dots: true,
      arrows: true,
      infinite: testimonials?.length > 2,
      centerMode: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      variableWidth: true,
      focusOnSelect: false,
      prevArrow: <SliderArrow />,
      nextArrow: <SliderArrow />,
      beforeChange: () => {
        if (sliderRef.current?.innerSlider?.list) {
          const sliderHeight = sliderRef.current.innerSlider.list.offsetHeight;
          sliderRef.current.innerSlider.list.style.height = `${sliderHeight}px`;
        }
      },
      afterChange: (current: number) => {
        handleChange(current);
        if (sliderRef.current?.innerSlider?.list) {
          resizeSliderByActive(sliderRef.current.innerSlider.list);
        }
      },
      onReInit: () => {
        if (!sliderLoad) {
          if (sliderRef.current?.innerSlider?.list) {
            resizeSliderByActive(sliderRef.current?.innerSlider?.list);
          }
          setSliderLoad(true);
        }
      },
      responsive: [
      {
        breakpoint: 767,
        settings: {
          arrows: false,
          infinite: true,
          centerMode: false,
          variableWidth: false
        }
      }]

    };
  };

  const resizeSliderByActive = (list: HTMLDivElement) => {
    const sliderTrack = list.querySelector(".slick-track");
    const slideActive = list.querySelector(".slick-active");
    if (sliderTrack && slideActive) {
      list.style.height = `${
      parseInt(
        window.getComputedStyle(sliderTrack).getPropertyValue("padding-top")
      ) +
      parseInt(
        window.
        getComputedStyle(sliderTrack).
        getPropertyValue("padding-bottom")
      ) +
      slideActive.clientHeight
      }px`;
    }
  };

  return (
    <WidgetContainer highlight={highLight}>
      <div className={styles.testimonial1}>
        <h2
          className={styles.testimonial1Title}
          aria-label='testimonial-slider-title'>

          {t(
            `testimonials.title.${
            testimonialType === "CUSTOMER" ? "clients" : "allies"
            }`
          )}
        </h2>
        <Slider ref={sliderRef} {...settings()}>
          {testimonials?.map((testimonial, index) =>
          <TestimonialsCard
            testimonial={testimonial}
            key={`testimonial-${index}`}
            className={`testimonialItem testimonialItem${index}`} />

          )}
        </Slider>
      </div>
    </WidgetContainer>);

};

export default Testimonials1;